// extracted by mini-css-extract-plugin
export default {"link":"DownloadCSV__link--5AX9AR"};